import { useAuthContext } from "common/contexts/AuthContext";
import styled from "styled-components";

const SelectedHeader = styled.div`
  color: #005754;
  font-family: Poppins;
  font-size: 1em;
  font-style: normal;
  font-weight: 600;
  line-height: 1.33em; /* 133.333% */
`;

const FlexContainer = styled.div`
  display: flex;
  max-height: 5vh;
  align-items: center;
  width: 100%;
  @media (min-width: 1280px) {
    font-size: 16px;
    padding-left: 30px;
  }
  @media (max-width: 1280px) and (min-width: 1024px) {
    font-size: 14px;
    padding-left: 20px;
  }
  @media (max-width: 1024px) {
    font-size: 12px;
    padding-left: 10px;
  }
`;

const SelectedRoleHeader = () => {
  const { authConfig } = useAuthContext();
  return (
    <FlexContainer>
      <SelectedHeader>{authConfig?.user?.businessName}</SelectedHeader>
    </FlexContainer>
  );
};

export default SelectedRoleHeader;
